import { ColorEnum } from '@/constants/color'
import { Layout } from '@/features/layout/types'
import TransactionRow from '@/features/shiftCloseouts/components/CashTransactionHistory/parts/TransactionRow'
import { CashTransactionItem } from '@/features/shiftCloseouts/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface CashTransactionHistoryProps {
    layout: Layout
    transactions: CashTransactionItem[]
}

const CashTransactionHistory: FC<CashTransactionHistoryProps> = ({ layout, transactions }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h5">
                {t('shiftCloseouts.cashTransactions.historyHeading')}
            </Typography.Heading>

            {transactions.length === 0 ? (
                <Typography.Description style={styles.emptyStateText}>
                    {t('shiftCloseouts.cashTransactions.empty')}
                </Typography.Description>
            ) : (
                <View style={styles.list}>
                    {transactions.map((transaction) => (
                        <TransactionRow
                            key={transaction.id}
                            layout={layout}
                            transaction={transaction}
                        />
                    ))}
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 16,
    },
    list: {
        gap: 8,
    },
    emptyStateText: {
        color: ColorEnum.GRAY_600,
    },
})

export default CashTransactionHistory
